import "./InputDate.scss";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import {
  DATEPICKER_DEFAULT_MAX_DATE,
  DATEPICKER_DEFAULT_MIN_DATE,
  LANG,
} from "constants/constants";
import { useEffect, useState } from "react";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { format } from "date-fns";
import fr from "date-fns/locale/fr";
import enUS from "date-fns/locale/en-US";
import { parseValue } from "utils/helper";

registerLocale("fr", fr);
registerLocale("en", enUS);

const FromToInputDate = ({
  errors,
  idFrom,
  idTo,
  label,
  lang,
  onChangeFrom,
  onChangeTo,
  required,
  valueFrom,
  valueTo,
  showMonthYearPicker = false,
  readOnly = false,
}) => {
  const formatPlaceholder = () => (lang === LANG.EN ? "MM/DD/YY" : "JJ/MM/AA");

  const [selectedDateFrom, setSelectedDateFrom] = useState(
    parseValue(valueFrom)
  );
  const [selectedDateTo, setSelectedDateTo] = useState(parseValue(valueTo));

  useEffect(() => {
    setSelectedDateFrom(parseValue(valueFrom));
  }, [valueFrom]);

  useEffect(() => {
    setSelectedDateTo(parseValue(valueTo));
  }, [valueTo]);

  const handleDateChange = (date, setState, onChange) => {
    setState(date);
    if (onChange) {
      const formattedDate = date ? format(date, "yyyy-MM-dd") : "";
      onChange(label ? { target: { value: formattedDate } } : formattedDate);
    }
  };

  const dateFormat = showMonthYearPicker
    ? "MM/yyyy"
    : lang === LANG.EN
      ? "MM/dd/yyyy"
      : "dd/MM/yyyy";

  return (
    <div className={`input-date sourcesanspro-normal-gray-suit-18px`}>
      <div className={label ? "overlap-group" : "display-modal-title"}>
        <div className="flex-col">
          <div className="sourcesanspro-normal-shadow-blue-14px">
            {label && (
              <label className={errors?.ref ? "label-error" : "label-standard"}>
                {typeof label === "string" ? (
                  label
                ) : (
                  <FormattedMessage {...label} />
                )}
                {required && "*"}
              </label>
            )}
          </div>
          <div className="from-to-dates">
            <div className="date-input-container">
              <DatePicker
                id={idFrom}
                selected={selectedDateFrom}
                onChange={(date) =>
                  handleDateChange(date, setSelectedDateFrom, onChangeFrom)
                }
                onMonthChange={(date) =>
                  handleDateChange(date, setSelectedDateFrom, onChangeFrom)
                }
                onYearChange={(date) =>
                  handleDateChange(date, setSelectedDateFrom, onChangeFrom)
                }
                locale={lang === LANG.EN ? "en" : "fr"}
                dateFormat={dateFormat}
                placeholderText={formatPlaceholder()}
                minDate={DATEPICKER_DEFAULT_MIN_DATE}
                maxDate={selectedDateTo || DATEPICKER_DEFAULT_MAX_DATE}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                yearDropdownItemNumber={50}
                scrollableYearDropdown
                showMonthYearPicker={showMonthYearPicker}
                disabled={readOnly}
                className={`sourcesanspro-normal-gray-suit-18pxmt-10 ${
                  errors?.ref ? "error" : ""
                }`}
                style={{
                  width: "100%",
                }}
              />
            </div>
            <div
              className={`input-value sourcesanspro-normal-gray-suit-18pxmt-10`}
              style={{
                color: "#666",
                fontWeight: "normal",
                cursor: "default",
                padding: "0 8px",
                margin: "0 1rem",
              }}
            >
              -
            </div>
            <div className="date-input-container">
              <DatePicker
                id={idTo}
                selected={selectedDateTo}
                onChange={(date) =>
                  handleDateChange(date, setSelectedDateTo, onChangeTo)
                }
                onMonthChange={(date) =>
                  handleDateChange(date, setSelectedDateTo, onChangeTo)
                }
                onYearChange={(date) =>
                  handleDateChange(date, setSelectedDateTo, onChangeTo)
                }
                locale={lang === LANG.EN ? "en" : "fr"}
                dateFormat={
                  showMonthYearPicker
                    ? lang === LANG.EN
                      ? "MM/yyyy"
                      : "MM/yyyy"
                    : lang === LANG.EN
                      ? "MM/dd/yyyy"
                      : "dd/MM/yyyy"
                }
                placeholderText={formatPlaceholder()}
                minDate={selectedDateFrom || DATEPICKER_DEFAULT_MIN_DATE}
                maxDate={DATEPICKER_DEFAULT_MAX_DATE}
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                yearDropdownItemNumber={50}
                scrollableYearDropdown
                showMonthYearPicker={showMonthYearPicker}
                disabled={readOnly}
                className={`sourcesanspro-normal-gray-suit-18pxmt-10 ${
                  errors?.ref ? "error" : ""
                }`}
                style={{
                  width: "100%",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FromToInputDate.propTypes = {
  errors: PropTypes.any,
  idFrom: PropTypes.any.isRequired,
  idTo: PropTypes.any.isRequired,
  label: PropTypes.object,
  lang: PropTypes.string,
  onChangeFrom: PropTypes.func,
  onChangeTo: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  valueFrom: PropTypes.string,
  valueTo: PropTypes.string,
  showMonthYearPicker: PropTypes.bool,
};

FromToInputDate.defaultProps = {
  errors: null,
  label: null,
  lang: LANG.EN,
  onChangeFrom: null,
  onChangeTo: null,
  readOnly: false,
  required: false,
  valueFrom: "",
  valueTo: "",
  showMonthYearPicker: false,
};

export default FromToInputDate;
